import ConsultantMissionBalancesheet from "./ConsultantMissionBalancesheet";
import MissionBalancesheetPage from "./MissionBalancesheetPage";
import { Navigate, Route, useLocation, useParams } from "react-router-dom";

const MISSION_BALANCESHEET_PUBLIC_PATH =
  "davidson-evaluation/mission/:slug/:token";

const MissionBalancesheetLegacyRedirect = () => {
  const { slug, token } = useParams();
  const { search } = useLocation();

  return (
    <Navigate
      replace
      to={`/davidson-evaluation/mission/${slug}/${token}${search}`}
    />
  );
};

const routes = {
  key: "MISSION_BALANCESHEET",
  routes: ({ userScope }) => [
    <Route
      key={"consultant-mission-balancesheet"}
      path={`${userScope}/balancesheet/mission/:missionId/:evaluationId`}
      element={<ConsultantMissionBalancesheet />}
    />,
    <Route
      key="mission-balancesheet-legacy"
      path={`balancesheet/mission/slug/:slug/:token`}
      element={<MissionBalancesheetLegacyRedirect />}
    />,
    <Route
      key="mission-balancesheet-public"
      path={MISSION_BALANCESHEET_PUBLIC_PATH}
      element={<MissionBalancesheetPage />}
    />,
  ],
};
export default routes;
